var Stamp = require('./stamp'),
    _ = require('underscore'),
    NormalizeNewLineCharacters = require('../../FV/util').normalizeNewLineCharacters;



module.exports = Stamp.extend({

    SUPPORTED_TOKENS: [ '$date', '$time' ],

    constructor: function( attrs, options ) {

        /* Normalize EOL white space on way in -- Raphael relies on '\n' -- printing text */
        attrs.src = NormalizeNewLineCharacters( attrs.src );

        Stamp.apply( this, arguments );

        // Note: unique ( dupes are populated with the same value )
        this.aVariables = this.setVariables();

        // Also unique -- any that are the same would have the same value
        this.aTokens = this.setTokens();

    },

    getText: function() {
        return this.get('src');
    },

    setVariables: function() {

        var txt = this.getText();

        // Check when called from constructor and attributes haven't been sent
        if ( !txt  )
            return [];

        // Get words starting with % but don't catch % in words starting with % -- eg: %before%after should be one match
        // Rule is that all variables must be separated by white space
        var variables = this.getText().match( /%[\w|%]+/g ); // old:  /\$\w+/g -- this would provide %before%after

        return variables !== null
            ? _.uniq(variables)
            : [];

    },

    setTokens: function() {

        var txt = this.getText();

        // Check when called from constructor and attributes haven't been sent
        if ( !txt  )
            return [];

        // No rule they must be separated by white-space
        // Unlike variables, the names are pre-defined and you wouldn't run into the same issues
        var tokens = this.getText().match( /\$\w+/g );

        return tokens !== null
            ? _.intersection( this.SUPPORTED_TOKENS, _.uniq(tokens) )
            : [];

    },

    getVariables: function() {

        return this.aVariables;
    },

    getTokens: function() {

        return this.aTokens;

    },

    hasVariables: function() {

        return this.aVariables.length > 0;

    },

    hasTokens: function() {

        return this.getTokens().length > 0;

    },

    isDerivedFromPageNote: function() {

        return this.get('id') === 0;


    }



});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/stamps/textStamp.js
 ** module id = 96
 ** module chunks = 0
 **/